import api from "../services/api";

// Baixa um arquivo de um endpoint autenticado (o axios anexa o token). Usa
// responseType blob e dispara o download no navegador. Ex.: exportação .xlsx.
export async function downloadFile(url, filename, params = {}) {
  const res = await api.get(url, { params, responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}
